import { colors } from '@kmns-internal/furikake'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import {
  type NumberCondition,
  NumberLogicTypeEnum,
  type TemplateNodeSchema,
} from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { useDispatch } from 'react-redux'
import StyledIndentation from 'src/features/templateEdit/common/StyledIndentation'
import { deleteTemplateNode } from 'src/state/ducks/templates/actions'
import LogicContent from './LogicContent'

const NumberConditionLogic: FC<{
  id: number
  parentNode: TemplateNodeSchema
  node: TemplateNodeSchema
  path: number[]
  numberCondition: NumberCondition
}> = ({ id, parentNode, node, path, numberCondition: { logicType } }) => {
  const dispatch = useDispatch()
  const onClick = () => {
    dispatch(deleteTemplateNode(id, parentNode))
  }

  const logicTitle =
    logicType === NumberLogicTypeEnum.NORMAL ? '正常値' : '違反値'

  return (
    <Box data-testid="logic-wrapper" sx={{ ml: 2 }}>
      <Stack
        direction="row"
        alignItems="center"
        sx={{ backgroundColor: colors.primary.focusVisible, height: 48, px: 1 }}
      >
        <Typography variant="subtitle1">
          「{logicTitle}」を入力した場合
        </Typography>
        <Tooltip title="条件分岐の削除">
          <IconButton
            onClick={onClick}
            size="small"
            aria-label="条件分岐の削除"
          >
            <DeleteOutlineIcon sx={{ color: colors.error.main }} />
          </IconButton>
        </Tooltip>
      </Stack>
      <div style={{ display: 'flex' }}>
        <StyledIndentation color={colors.primary.focusVisible} />
        <LogicContent node={node} path={path} />
      </div>
    </Box>
  )
}

export default NumberConditionLogic
